export const DEFAULT_MAX_CLOUD_COVERAGE_PERCENT = 50;
